import GetShopPaymentPagedListRequestModelBase from '../_generated/modelBases/get-shop-payment-paged-list-request-model-base';

export default class GetShopPaymentPagedListRequestModel extends GetShopPaymentPagedListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
